import { useEffect } from "react";
import { App } from "antd";

let _modal = null;
let _message = null;
let _notification = null;

export const StaticFunctionsBridge = () => {
  const { modal, message, notification } = App.useApp();

  useEffect(() => {
    _modal = modal;
    _message = message;
    _notification = notification;
  }, [modal, message, notification]);

  return null;
};

export const getModal = () => _modal;
export const getMessage = () => _message;
export const getNotification = () => _notification;
